import { CopiedGrid } from '../../../../../orders/orderState.types';
import useCopyPasteGrid from '../../../../../orders/products/hooks/useCopyPasteGrid';
import { OrderProductGridItem } from '../../../../../orders/products/orderProducts.types';
import { OrderProductForGridContainer } from '../../../../../orders/products/product/grid/components/orderProductGrid/components/grid/types/orderProductGridContainer.types';
import { useCatalogListCopiedGrid } from '../contexts/CatalogListCopiedGrid.context';

interface UseCatalogListRowCopyPasteParams {
  product: OrderProductForGridContainer;
  grid: OrderProductGridItem[];
  orderId?: string;
  selectedOrderId?: string;
  resetSelectedPacks: () => void;
  onNoSelectedOrder: () => void;
}

interface UseCatalogListRowCopyPasteResult {
  copiedGrid: CopiedGrid;
  copyGrid: (grid: CopiedGrid) => void;
  removeCopiedGrid: () => void;
  onClickPaste: () => Promise<void>;
}

const useCatalogListRowCopyPaste = ({
  product,
  grid,
  orderId,
  selectedOrderId,
  resetSelectedPacks,
  onNoSelectedOrder,
}: UseCatalogListRowCopyPasteParams): UseCatalogListRowCopyPasteResult => {
  const { copiedGrid, copyGrid, removeCopiedGrid } = useCatalogListCopiedGrid();

  const { onClickPaste } = useCopyPasteGrid({
    copiedGrid,
    product,
    orderId,
    grid,
    resetSelectedPacks,
  });

  const handleClickPaste = async () => {
    if (!orderId || !selectedOrderId) {
      onNoSelectedOrder();
      return;
    }

    await onClickPaste();
  };

  return { copiedGrid, copyGrid, removeCopiedGrid, onClickPaste: handleClickPaste };
};

export default useCatalogListRowCopyPaste;
